import PageBuilder from "../../wealth/tenant/admin/page/PageBuilder";
import PageDashboard from "../../wealth/tenant/admin/page/PageDashboard";
import PageMarketing from "../../wealth/tenant/admin/page/PageMarketing";
import PagePeople from "../../wealth/tenant/admin/page/PagePeople";
import PageProducts from "../../wealth/tenant/admin/page/PageProducts";
import PageProposals from "../../wealth/tenant/admin/page/PageProposals";
import PageSettings from "../../wealth/tenant/admin/page/PageSettings";

export default [
  {
    path: "/bx-admin-portal/dashboard",
    Component: PageDashboard,
  },
  {
    path: "/bx-admin-portal/people",
    Component: PagePeople,
  },
  {
    path: "/bx-admin-portal/proposals",
    Component: PageProposals,
  },
  {
    path: "/bx-admin-portal/builder",
    Component: PageBuilder,
  },
  {
    path: "/bx-admin-portal/products",
    Component: PageProducts,
  },
  {
    path: "/bx-admin-portal/marketing",
    Component: PageMarketing,
  },
  {
    path: "/bx-admin-portal/settings",
    Component: PageSettings,
  },
];
